<template>
    <span @click.prevent="openModal">
        <slot />
    </span>
</template>

<script>
export default {
    props: {
        mode: {
            type: String,
            validator: function(value) {
                return ["create", "edit"].indexOf(value) !== -1;
            }
        },
        data: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        openModal() {
            this.$root.$refs.modalContractPeriod.openModal(
                this.mode,
                this.data
            );
        }
    }
};
</script>
